import { combineReducers } from 'redux'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import { INotifiesState } from '../types'
import communications from './communications'
import data from './data'

export const reducedWithComm = combineReducers<INotifiesState>({
  communications,
  data,
})

const persistConfig = {
  key: 'notifies',
  storage,
  version: 1,
  blacklist: ['communications'],
}

export const reducer = persistReducer(persistConfig, reducedWithComm)
